import { Component, OnInit, OnDestroy, AfterViewInit, EventEmitter, Input, Output, ViewChild, TemplateRef } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Producto } from '../../../models/producto';
import { ProductoService } from '../../../services/producto.service';
import { Pagination } from '../../../models/pagination';
import { InputSearchComponent } from '../../../controls/input-search/input-search.component';
import { SessionService } from '../../../services/session.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs/Subscription";
import { ConfigService } from '../../../config/config-service';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { ParametroService } from '../../../services/parametro.service';
import { environment } from '../../../../environments/environment';
import { Categoria } from '../../../models/categoria';
import { Marca } from '../../../models/marca';
import { CategoriaService } from '../../../services/categoria.service';
import { MarcaService } from '../../../services/marca.service';

@Component({
	selector: 'app-producto-precio-modal',
	templateUrl: './producto-precio-modal.component.html',
	styleUrls: ['./producto-precio-modal.component.css'],
	providers: [ProductoService,BsModalService,ParametroService,CategoriaService, MarcaService]
})
export class ProductoPrecioModalComponent implements OnInit,OnDestroy,AfterViewInit {
	@Output() sendProductoPrecio = new EventEmitter();
	@Input() bodega_id: any;
	@Input() productoservicio: boolean = false;
	@Input() tipo_producto_id: string = "";
	@Input() es_consumible: boolean = false;
	// @Input() tipo_producto_id: String = "0";
	@Input() numero_decimales: number = 2;
	@Input() es_comprado: boolean;
	@Input() es_vendido: boolean;
	@ViewChild(InputSearchComponent) inputSearch: InputSearchComponent;
	public title: String;
	public productos: Array<Producto> = [];
	public selectedRow: number;
	private producto;
	public pagination: Pagination;
	public loading = false;
	public text: String;
	public Mod_Inventario: string;
	private _modelSubscription: Subscription;
	public ruta_imagen: String;
	public config: ConfigService;
	//public numero_decimales: number;
	public format_decimal: String;
	public uploadfile_api: String;
	public categorias: Array<Categoria>;
	public categoria: Categoria;
	public marcas: Array<Marca>;
	public marca: Marca;
	public busqueda: String;
	constructor(
		public productoService: ProductoService,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		public bsModalRefImg: BsModalRef,
		private ss: SessionService,
		private modalService: BsModalService,
		private modalServiceImg: BsModalService,
		private parametroService: ParametroService,
		public categoriaService: CategoriaService,
   		private marcaService: MarcaService,
	) {
		this.title = "Productos";
		this.text = "";
		this.pagination = new Pagination();
		this.Mod_Inventario = this.ss.getData("mod_inventario");
		this.ruta_imagen = "";
		this.config = new ConfigService();
		//this.numero_decimales = 2;
		this.format_decimal = "0,0.00";
		this.uploadfile_api = environment.uploadfile_api;
		this.categorias = [];
		this.marcas = [];
		this.categoria = new Categoria();
		this.marca = new Marca();
		this.busqueda = "";
	}

	ngOnInit() {
		let digitos = "";
		for(let i = 0; i < this.numero_decimales; i++) digitos += "0";
		this.format_decimal = "0,0." + digitos
		this.loading = true;

		let p1 = this.getProductos();
		let p2 = this.getCategorias();
		let p3 = this.getMarcas();
		Promise.all([p1,p2,p3]).then(
		res => this.loading = false,
		err => this.loading = false
		);
		

		this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
			this.getProductos();
		});
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	ngAfterViewInit(){
		this.inputSearchListen();
	}

	inputSearchListen(){
		this.inputSearch.onSearch.subscribe(
			res => {
				this.text = res;
			},
			err => {
				//
			}
		);
	}

	getCategorias() {
		return new Promise((resolve, reject) => {
		  this.categoriaService.getAll().subscribe(
			res => {
			  if (res.data.length) {
				this.categorias = res.data;
			  } else {
				this.categorias = [];
			  }
			  resolve(true);
			},
			err => {
			  this.categorias = [];
			  reject();
			}
		  );
		});
	  }

	getMarcas() {
		return new Promise((resolve,reject)=>{
		  this.marcaService.getAll().subscribe(
			res => {
			  this.marcas = res.data;
			  resolve(true);
			},
			err => {
			  reject();
			  this.marcas = [];
			  
			}
		  );
		})
			
	}

	getQs(event:string=null){
		let qs = "";
		// if(campo == 'text' && text == ''){
		// 	this.busqueda = text;
		// }
	
		if(this.categoria.id){
			qs += "&categoria_id=" + this.categoria.id;
		}
		if(this.marca.id){
			qs += "&marca_id=" + this.marca.id; 
		}
		
		if(event != null){
			this.busqueda = event;
		}
		
		
		
		if(this.busqueda){
			qs += "&q[producto.codigo]=" + this.busqueda + "&q[producto.nombre]=" + this.busqueda + "&q[producto.descripcion]=" + this.busqueda;
		}
		return qs;
	}

	getProductosBySearch(event){
		let qs = this.getQs(event);
		console.log(this.text);
		// this.pagination.current_page = 1;
		this.pagination = new Pagination();
		this.getProductos(qs);
	}

	getProductos(qs = "") {
		this.loading = true;
		let qstipoproductoid = "";

		if( this.tipo_producto_id ){
			qstipoproductoid = "&tipo_producto_id=" + this.tipo_producto_id;
		}else{
			qstipoproductoid = "";
		}

		if(this.es_comprado){
			qs += "&es_comprado=" + this.es_comprado;
		}
		if(this.es_vendido){
			qs += "&es_vendido=" + this.es_vendido;
		}

		this.productoService.getWithPrice(this.bodega_id, '?page='+this.pagination.current_page+'&per_page=10' + qstipoproductoid + qs).subscribe(
			res => {
				this.loading = false;
				this.selectedRow = null;
				this.productos = res.data;
				this.pagination.current_page = res.current_page;
				this.pagination.from = res.from;
				this.pagination.to = res.to;
				this.pagination.total = res.total;
				this.pagination.last_page = res.last_page;
				this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
				this.pagination.prev_disabled = this.pagination.current_page === 1;
			},
			err => {
				this.loading = false;
				this.productos = [];
			}
		);
	}

	/*getParamNumeroDecimales(){
        return new Promise((resolve, reject) => {
            let numero_decimales = 19;
            this.parametroService.getById(numero_decimales).subscribe(
                res => {
                    this.numero_decimales = res.valor;

                    let digitos = "";
                    for(let i = 0; i < this.numero_decimales; i++) digitos += "0";

                    this.format_decimal = "0,0." + digitos
                    resolve();
                },
                err => {
                    this.numero_decimales = 2;
                    this.format_decimal = "0,0.00"
                    reject(err);
                }
            );
        });
	}*/
	
	get formatDecimal(){
        return this.format_decimal;
    }

	onSelectRow(producto, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de producto
		this.producto = producto;
	}

	onDBLClick(producto, i) {
		this.onSelectRow(producto, i);
		this.onSubmit();
	}

	onSubmit() {
		//if (this.producto.cantidad_stock > 0) {
			//envía de objecto producto
			this.sendProductoPrecio.emit(this.producto);
			// this.getProductos();
			//Cierre de modal o componente
			// this.bsModalRef.hide();
		//}
	}

	next(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page++;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	prev(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page--;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	first(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page = 1;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	last(){
		// let qs = "&q[producto.codigo]=" + this.text + "&q[producto.nombre]=" + this.text + "&q[producto.descripcion]=" + this.text;
		this.pagination.current_page = this.pagination.last_page;
		let qs = this.getQs();
		this.getProductos(qs);
		
	}

	openModal(template: TemplateRef<any>){
		const initialState = {};
		this.bsModalRef2 = this.modalService.show(template, Object.assign({}, {class: 'modal-xlg', initialState}));
	}

	onImage(producto){
		this.ruta_imagen = this.uploadfile_api + "/image/" + (producto.imagen!=""?producto.imagen:"nofoto.png") + "/300?tk=" + this.ss.getData('api-token') + "&dbname=" + this.ss.getData('dbname');

		const initialState = { title: producto.nombre, ruta_image: this.ruta_imagen };
		this.bsModalRefImg = this.modalServiceImg.show(ImageModalComponent, Object.assign({}, {class: 'modal-sm', initialState}));
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/producto-precio-modal/producto-precio-modal.component.ts